const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

export const sendStripeReq = async (stripe, card, name) => {
  try {
    const res = await stripe.createPaymentMethod({
      type: 'card',
      card,
      billing_details: {
        name,
      },
    });
    return res;
  } catch (e) {
    return e;
  }
};

export const subscribeToPriceChange = async (pollingId) => {
  const url = `${REACT_APP_API_URL}/polling/get-result/${pollingId}`;

  try {
    const responseData = await fetch(url, { method: 'GET' });
    const response = await responseData.json();
    const { data, errors } = response;

    if (responseData.status === 202) {
      return await subscribeToPriceChange(pollingId);
    }

    if (data) {
      return data?.result_data;
    } else {
      return { errors };
    }
  } catch (e) {
    console.error(e);
    return { errors: { messages: 'An error has occurred (look at console)' } };
  }
};

export const getPollingID = async (
  nonce,
  plan,
  token,
  analyticsParams,
  eventsData,
  onErrorHandler,
  payment_intent_id,
  coupon
) => {
  const url = `${REACT_APP_API_URL}/users/me/subscriptions/polling/${plan}`;
  const requestData = {
    ...analyticsParams,
    user_data: {
      ...analyticsParams['user_data'],
      ...eventsData,
    }
  };

  const body = {
    gateway: 'stripe',
    payment_method_nonce: nonce,
    coupon: coupon || '',
    payment_intent_id,
    ...requestData,
  };

  try {
    const data = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const res = await data.json();
    const {
      data: { polling_result_id },
    } = res;

    return polling_result_id;
  } catch (e) {
    onErrorHandler(e.response?.data?.errors?.messages);
  }
};

export const getSubscriptionID = async (
  nonce,
  plan,
  token,
  analyticsParams,
  eventsData,
  coupon,
) => {
  const url = `${REACT_APP_API_URL}/users/me/subscriptions/${plan}`;
  const requestData = {
    ...analyticsParams,
    user_data: {
      ...analyticsParams['user_data'],
      ...eventsData,
    },
  };

  const body = {
    gateway: 'braintree',
    payment_method_nonce: nonce,
    coupon: coupon || '',
    ...requestData,
  };

  try {
    const results = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const res = await results.json();

    return res;
  } catch (e) {
    return e.response?.data || { errors: 'An error has occurred' };
  }
};
